"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTPayLogo = function SvgTPayLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 50 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t-pay-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.612 0H10.388C4.651 0 0 4.701 0 10.5S4.651 21 10.388 21h29.224C45.349 21 50 16.299 50 10.5S45.349 0 39.612 0Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.692 7.39h-4.146v6.693h2.017v-1.8h2.127c.5 0 .987-.016 1.461-.17.919-.295 1.6-1.124 1.6-2.249s-.668-1.94-1.572-2.263c-.5-.183-.974-.211-1.489-.211h.002Zm-2.128 3.318V9.007h1.837c.39 0 .613.043.793.112.32.127.472.421.472.732 0 .337-.181.66-.528.773-.167.056-.361.084-.737.084h-1.837ZM31.644 11.636l.959-2.699h.154l.959 2.7h-2.072Zm-.5 1.477h3.06l.39.97h2.266L34.147 7.39h-2.95l-2.712 6.693h2.281l.376-.97h.002ZM41.769 7.39l-1.64 3.05h-.071l-1.655-3.05h-2.35l2.99 4.92v1.773h2.087v-1.941l2.838-4.752h-2.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.033 5.404h11.204V11.1c0 1.46-.771 2.81-2.021 3.54l-3.58 2.089-3.581-2.09a4.094 4.094 0 0 1-2.022-3.54V5.405Z",
    fill: "#FFDD2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.107 8.402v1.77c.24-.273.675-.458 1.173-.458h.541v2.06c0 .548-.147 1.027-.366 1.291h2.355c-.217-.264-.364-.743-.364-1.29v-2.06h.54c.499 0 .935.185 1.174.46V8.404H9.105l.002-.002Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "t-pay-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v21H0z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTPayLogo);
var _default = exports["default"] = Memo;